import styled, { css } from 'styled-components';
import { ThemeProvider as MHUIThemeProvider } from '@marekhealth/mhui';

export const ThemeProvider = styled(MHUIThemeProvider).attrs({
  globalStyle: () => css`
    body > div {
      display: flex;
      align-items: center;
      min-height: 100vh;
    }
  `,
})``;
